<template>
  <a-layout id="components-layout">
    <a-layout-header class="header" theme="light">
      <div class="logo-dashboard" :style="logo">
        <router-link to="/home"></router-link>
      </div>
      <a-menu
        theme="light"
        mode="horizontal"
        :style="{ lineHeight: '64px', background: 'transparent' }"
      >
        <a-menu-item key="1" :style="{ float: 'right' }">
          <a-button
            type="primary"
            :style="{ background: '#11509b', border: 0, borderRadius: 0 }"
          >
            <router-link to="/login">{{ $t('js.dang_nhap') }}</router-link>
          </a-button>
        </a-menu-item>
      </a-menu>
    </a-layout-header>
    <a-layout>
      <a-layout-content>
        <div
          :style="{
            background: 'transparent',
            width: '600px',
            margin: 'auto',
            padding: '10px 0',
          }"
        >
          <h2>{{ $t('js.thong_tin_don_hang') }}</h2>
          <a-form
            id="components-form-demo-validate-other"
            ref="ruleForm"
            :model="form"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-form-item :label="$t('js.ten_nguoi_lien_he')" name="customer_name">
              <a-input
                v-model:value="form.customer_name"
                :placeholder="$t('js.vui_long_nhap_ten_nguoi_lien_he')"
              >
              </a-input>
            </a-form-item>
            <a-form-item :label="$t('js.so_dien_thoai')" name="customer_mobile_no">
              <a-input
                v-model:value="form.customer_mobile_no"
                :placeholder="$t('js.vui_long_nhap_so_dien_thoai')"
              >
              </a-input>
            </a-form-item>
            <a-form-item label="Email" name="email">
              <a-input
                v-model:value="form.email"
                :placeholder="$t('js.vui_long_nhap_email')"
              ></a-input>
            </a-form-item>
            <a-form-item :label="$t('js.tinh_thanh_pho')" name="ETD_province">
              <a-select
                show-search
                label-in-value
                :allowClear="true"
                :autoClearSearchValue="true"
                v-model:value="form.ETD_province"
                @change="onChangeProvince($event)"
                :placeholder="$t('js.vui_long_chon_tinh_thanh')"
                style="width: 100%; border-left: none; position: relative"
                :filter-option="false"
                @search="fetchLocationProvince"
                :loading="loading"
              >
                <a-select-option v-for="d in list_province" :key="d.value">
                  {{ d.text }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :label="$t('js.quan_huyen')" name="ETD_district">
              <a-select
                show-search
                label-in-value
                :allowClear="true"
                :autoClearSearchValue="true"
                :disabled="disableDes"
                v-model:value="form.ETD_district"
                @change="onChangeDistrict($event)"
                :placeholder="$t('js.vui_long_chon_quan_huyen')"
                style="width: 100%; border-left: none; position: relative"
                :filter-option="false"
                @search="fetchLocationDistrict"
                :loading="loading"
              >
                <a-select-option v-for="d in list_district" :key="d.value">
                  {{ d.text }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :label="$t('js.dia_chi_nhan_hang')" name="ETD_address">
              <a-input
                v-model:value="form.ETD_address"
                :placeholder="$t('js.vui_long_nhap_dia_chi_nhan_hang')"
              >
              </a-input>
            </a-form-item>
            <a-form-item :label="$t('js.thoi_gian_nhan_hang')" name="ETD_date">
              <a-date-picker
                v-model:value="form.ETD_date"
                :locale="locale"
                format="DD-MM-YYYY"
                :style="{ width: '50%' }"
              />
              <a-time-picker
                v-model:value="form.ETD_time"
                :locale="locale"
                format="HH:mm"
                :style="{ marginLeft: '8px', width: '40%' }"
              />
            </a-form-item>
            <a-form-item :label="$t('js.tinh_thanh_pho')" name="ETA_province">
              <a-select
                show-search
                label-in-value
                :allowClear="true"
                :autoClearSearchValue="true"
                v-model:value="form.ETA_province"
                @change="onChangeProvinceArr($event)"
                :placeholder="$t('js.vui_long_chon_tinh_thanh')"
                style="width: 100%; border-left: none; position: relative"
                :filter-option="false"
                @search="fetchLocationProvinceArr"
                :loading="loading"
              >
                <a-select-option v-for="d in list_province_arr" :key="d.value">
                  {{ d.text }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :label="$t('js.quan_huyen')" name="ETA_district">
              <a-select
                show-search
                label-in-value
                :allowClear="true"
                :disabled="disableArr"
                :autoClearSearchValue="true"
                v-model:value="form.ETA_district"
                @change="onChangeDistrictArr($event)"
                :placeholder="$t('js.vui_long_chon_quan_huyen')"
                style="width: 100%; border-left: none; position: relative"
                :filter-option="false"
                @search="fetchLocationDistrictArr"
                :loading="loading"
              >
                <a-select-option v-for="d in list_district_arr" :key="d.value">
                  {{ d.text }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :label="$t('js.dia_chi_tra_hang')" name="ETA_address">
              <a-input
                v-model:value="form.ETA_address"
                :placeholder="$t('js.vui_long_nhap_dia_chi_tra_hang')"
              >
              </a-input>
            </a-form-item>
            <a-form-item :label="$t('js.thoi_gian_tra_hang')" name="ETA_date">
              <a-date-picker
                v-model:value="form.ETA_date"
                :locale="locale"
                format="DD-MM-YYYY"
                :style="{ width: '50%' }"
              />
              <a-time-picker
                v-model:value="form.ETA_time"
                :locale="locale"
                format="HH:mm"
                :style="{ marginLeft: '8px', width: '40%' }"
              />
            </a-form-item>
            <a-form-item :label="$t('js.quang_duong')" name="distance">
              <a-input-number
                v-model:value="form.distance"
                :min="0"
                :max="999999"
                style="width: 50%"
                :formatter="formatter"
                :parser="parser"
                :placeholder="$t('js.vui_long_nhap_quang_duong')"
              />
            </a-form-item>
            <a-form-item :label="$t('js.tong_dung_tich')" name="volume">
              <a-input-number
                v-model:value="form.volume"
                :min="0"
                :max="999999"
                style="width: 50%"
                :formatter="formatter"
                :parser="parser"
                :placeholder="$t('js.vui_long_nhap_dung_tich')"
              />
            </a-form-item>
            <a-form-item :label="$t('js.tong_khoi_luong')" name="weight">
              <a-input-number
                v-model:value="form.weight"
                :min="0"
                :max="999999"
                style="width: 50%"
                :formatter="formatter"
                :parser="parser"
                :placeholder="$t('js.vui_long_nhap_khoi_luong')"
              />
            </a-form-item>
            <!-- <a-form-item :label="$t('js.so_luong_chuyen')" name="route_number">
              <a-input-number
                v-model:value="form.route_number"
                :min="0"
                :max="999999"
                style="width: 50%"
                :formatter="formatter"
                :parser="parser"
                :placeholder="$t('js.vui_long_nhap_so_luong_chuyen')"
              />
            </a-form-item> -->
            <a-form-item :wrapper-col="{ span: 24 }" style="text-align: center">
              <a-button
                type="primary"
                @click="onSubmit"
                :loading="loadingCofirm"
                >{{ $t('js.tao_don_hang') }}</a-button
              >
            </a-form-item>
          </a-form>
        </div>
      </a-layout-content>
      <a-layout-footer :style="{ textAlign: 'center' }" class="footer-layout">
        CETA ©2020 Created by OneLog
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>
<script>
import { datePickerLocale as locale } from "@/common/locale";
import moment from "moment/moment";
import Location from "./Location.vue";
import VehicleGroup from "./VehicleGroup.vue";
import LocationService from "@/services/LocationService";
import axios from "axios";
import constant from "@/constant";
import { EnvironmentOutlined } from "@ant-design/icons-vue";
import OneLogSelect from "@/components/Select/OneLogSelect";
import debounce from "lodash/debounce";
import { notification } from "ant-design-vue";
export default {
  components: {
    Location,
    VehicleGroup,
    EnvironmentOutlined,
    "o-select": OneLogSelect,
  },
  data() {
    let validateProvince = (rule, value) => {
      if (typeof value === "undefined" || value == "") {
        return Promise.reject(window.__t('js.vui_long_tinh_thanh_pho'));
      } else {
        return Promise.resolve();
      }
    };
    let validateDistrict = (rule, value) => {
      if (typeof value === "undefined" || value == "") {
        return Promise.reject(window.__t('js.vui_long_quan_huyen'));
      } else {
        return Promise.resolve();
      }
    };
    this.fetchLocationProvince = debounce(this.fetchLocationProvince, 800);
    this.fetchLocationProvinceArr = debounce(
      this.fetchLocationProvinceArr,
      800
    );
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      disableDes: true,
      disableArr: true,
      loading: false,
      loadingCofirm: false,
      form: {
        customer_name: "",
        customer_mobile_no: "",
        email: "",
        ETD_province: void 0,
        ETD_district: void 0,
        ETD_address: "",
        ETD_date: void 0,
        ETD_time: void 0,
        ETA_province: void 0,
        ETA_district: void 0,
        ETA_address: "",
        ETA_date: void 0,
        ETA_time: void 0,
        distance: "",
        volume: "",
        weight: "",
        route_number: void 0,
        ETD_location: {},
        ETA_location: {},
      },
      rules: {
        customer_name: [
          { required: true, message: window.__t('js.vui_long_nhap_ho_ten'), trigger: "blur" },
        ],
        customer_mobile_no: [
          {
            required: true,
            message: window.__t('js.vui_long_nhap_so_dien_thoai'),
            trigger: "blur",
          },
        ],
        ETD_province: [
          {
            validator: validateProvince,
            trigger: ["change", "blur"],
            required: true,
          },
        ],
        ETA_province: [
          {
            validator: validateProvince,
            trigger: ["change", "blur"],
            required: true,
          },
        ],
        ETD_district: [
          {
            validator: validateDistrict,
            trigger: ["change", "blur"],
            required: true,
          },
        ],
        ETA_district: [
          {
            validator: validateDistrict,
            trigger: ["change", "blur"],
            required: true,
          },
        ],
      },
      AppConstant: constant.locationType,
      locale,
      moment,
      vehicleGroups: [],

      arrivalLocation: {},
      destinationLocation: {},
      destinationLocationModalVisible: false,
      arrivalLocationModalVisible: false,
      destinationReadOnly: "readonly",
      arrivalReadOnly: "readonly",

      formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      parser: (value) => value.replace(/\$\s?|(,*)/g, ""),
      logo: {
        backgroundImage:
          "url(" + require("@/assets/img/full_blue.png").default + ")",
        backgroundRepeat: "no-repeat",
      },
      params: {
        pageSize: 100,
        pageIndex: 1,
        filters: [],
      },
      list_province: [],
      list_district: [],
      list_province_arr: [],
      list_district_arr: [],
    };
  },
  mounted() {
    this.fetchLocationProvince();
    this.fetchLocationProvinceArr();
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.$refs.ruleForm.validate().then(() => {
        this.loadingCofirm = true;
        let form = {
          customer_name: this.form.customer_name,
          customer_mobile_no: this.form.customer_mobile_no,
          email: this.form.email,
          ETD_location: {
            address: this.form.ETD_address,
            full_address: this.form.ETD_address,
          },
          ETA_location: {
            address: this.form.ETA_address,
            full_address: this.form.ETA_address,
          },
          ETD_date: this.form.ETD_date,
          ETD_time: this.form.ETD_time,
          ETA_date: this.form.ETA_date,
          ETA_time: this.form.ETA_time,
          weight: this.form.weight,
          volume: this.form.volume,
          distance: this.form.distance,
        };

        form.ETD_location.province = this.form.ETD_province
          ? this.form.ETD_province.key
          : "";
        form.ETD_location.district = this.form.ETD_district
          ? this.form.ETD_district.key
          : "";

        form.ETA_location.province = this.form.ETA_province
          ? this.form.ETA_province.key
          : "";
        form.ETA_location.district = this.form.ETA_district
          ? this.form.ETA_district.key
          : "";

        axios
          .post("c-order-customer/anonymous-item", form)
          .then((response) => {
            if (response.data.errorCode == 0) {
              this.$refs.ruleForm.resetFields();
              notification.success({
                message: window.__t('js.them_moi_don_hang_thanh_cong'),
                description:
                  window.__t('js.ban_da_them_moi_don_hang_thanh_cong_ban_co_the_tiep_tuc_them_moi_cac_do_cd55fc60'),
                duration: 1.5,
              });
            }
            else{
              this.$message.error(response.data.errorMessage);
            }
            this.loadingCofirm = false;
          })
          .catch((error) => {
            this.$message.error(error);
            this.loadingCofirm = false;
          });
      });
    },

    onChangeProvince($event) {
      this.disableDes = false;
      if ($event) {
        this.form.ETD_province = $event;
        let field = "province_id";
        let value = $event ? $event.key : void 0;
        this.params[field] = value;
        this.fetchLocationDistrict();
      }
    },
    onChangeProvinceArr($event) {
      this.disableArr = false;
      if ($event) {
        this.form.ETA_province = $event;
        let value = $event ? $event.key : void 0;
        let params = {
          pageSize: 100,
          pageIndex: 1,
          province_id: value,
        };
        this.fetchLocationDistrictArr(params);
      }
    },
    onChangeDistrict($event) {
      this.form.ETD_district = $event;
    },
    onChangeDistrictArr($event) {
      this.form.ETA_district = $event;
    },
    onChangeLocation($event, item, field) {
      let value = $event ? $event.key : void 0;
      item.onLoad({ field, value });
    },
    fetchLocationProvince() {
      this.loading = true;
      LocationService.province(this.params)
        .then((response) => {
          if (response.data.errorCode == 0) {
            this.list_province = response.data.data.items.map((item) => ({
              text: item.title,
              value: item.id,
            }));
            this.loading = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error.message);
        });
    },
    fetchLocationDistrict() {
      this.loading = true;
      LocationService.district(this.params)
        .then((response) => {
          if (response.data.errorCode == 0) {
            this.list_district = response.data.data.items.map((item) => ({
              text: item.title,
              value: item.id,
            }));
            this.loading = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error.message);
        });
    },
    fetchLocationProvinceArr() {
      this.loading = true;
      LocationService.province(this.params)
        .then((response) => {
          if (response.data.errorCode == 0) {
            this.list_province_arr = response.data.data.items.map((item) => ({
              text: item.title,
              value: item.id,
            }));
            this.loading = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error.message);
        });
    },
    fetchLocationDistrictArr(params) {
      this.loading = true;
      LocationService.district(params)
        .then((response) => {
          if (response.data.errorCode == 0) {
            this.list_district_arr = response.data.data.items.map((item) => ({
              text: item.title,
              value: item.id,
            }));
            this.loading = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error.message);
        });
    },
  },
};
</script>
<style>
#components-layout .ant-layout-header {
  background: white;
}

#components-layout .logo-dashboard {
  width: 185px;
  height: 48px;
  margin-left: 16px;
  margin-top: 8px;
  float: left;
  -webkit-background-size: contain;
  background-size: contain;
}

#components-layout .ant-collapse-item .ant-collapse-header {
  font-weight: 700;
  background: white;
  opacity: 0.9;
  color: #11509b;
  font-size: 16px;
}
.footer-layout{
  position: absolute;
  width: 100%;
  bottom: 0;
  padding: 20px;
  background: #ededed;
}
</style>
